import React from "react";
import PartChip from "../atoms/PartChip";
import NoneChip from "../atoms/NoneChip";
import PartItem from "../atoms/PartItem";

const Part2dTab = ({personalItemObject,code, codeKeyData}) => {

  const switchData = personalItemObject.partPersonalization;
  const partCode = switchData.code;


  return (
    <div className={"tab-content active"}>
    <div className={"option"}>
      <div className={"option-list"}>
        <div style={{width: "100%"}}>
          <div className={"option-group-expand"}>
            <NoneChip codeKeyData={codeKeyData} code={partCode}/>
            <PartItem
              key={"PART2D_"+personalItemObject.id}
              item={personalItemObject}
              code={partCode}
              partKey={partCode}
            />

          </div>
        </div>


      </div>
    </div>
    </div>
  )
}
export default Part2dTab;
